module.exports = __webpack_public_path__ + "static/e0d278b7-3400-416c-b3a8-665f227ca17f-c6b8b21a04ef748dcd4094bc50fdc2af.jpg";